import { useEffect } from "react";
import { TailSpin } from "react-loader-spinner";
import { useNavigate, useSearchParams } from "react-router-dom";
import client from "../api/client";
import { useSetRecoilState } from "recoil";
import { authAtom } from "../recoil/atoms";
import jwtDecode from "jwt-decode";

const OAuth2 = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const setAuthAtom = useSetRecoilState(authAtom);
  useEffect(() => {
    const accessToken = searchParams.get("token");
    setAuthAtom({
      isLoggedIn: true,
      username: jwtDecode(accessToken).user.username,
      name: jwtDecode(accessToken).user.name,
    });
    client.defaults.headers.common["Authorization"] = `Bearer ${accessToken}`;
    navigate("/", { replace: true });
  }, []);
  return <TailSpin height={"100px"} width={"100px"} color={"grey"} />;
};
export default OAuth2;
